import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { Account, AccountSaveResponse } from '../../../types/Account';
import { AxiosError } from 'axios';
import { mutationKeys } from '../mutationKeys';

export const updateAccount = async (uuid: string, formData: AccountSaveResponse) => {
  const response = await CustomAxios.put(`accounts/${uuid}`, formData);
  const { data } = response;
  return data;
};
interface UseUpdateAccountFormProps {
  uuid: string;
  onSuccessCallback: () => void;
}
export function useUpdateAccount({ uuid, onSuccessCallback }: UseUpdateAccountFormProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateAccount],
    mutationFn: (formData: AccountSaveResponse) => updateAccount(uuid, formData),
    onSuccess: (data: Account) => {
      // fetch the account again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allAccounts, data.uuid] });

      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const data: AccountSaveResponse = err.response.data as AccountSaveResponse;
        queryClient.setQueryData([queryKeys.allAccounts, data.account.uuid], data);
      }
    },
  });
}
